export default __webpack_public_path__ + "static/tutorpoint-de41d517da176dd3a07d92bdef4edde1.svg";